export default __webpack_public_path__ + "static/media/Insurer.678950f5.svg";